var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "info-item",
      attrs: { id: "project__list__coordinator" },
      on: { click: _vm.showChangeEngagementManager }
    },
    [
      _c(
        "div",
        { staticClass: "info-bubbles exclude-outside-click" },
        [
          _vm.project.engagement_manager
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.html",
                      modifiers: { hover: true, html: true }
                    }
                  ],
                  staticClass:
                    "initials badge badge-primary cursor-pointer exclude-outside-click",
                  attrs: { title: _vm.project.engagement_manager.name }
                },
                [
                  _c("span", { staticClass: "exclude-outside-click" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("textInitials")(
                          _vm.project.engagement_manager.name
                        )
                      )
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("plus-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.addEngagementManagerFlag,
                expression: "!addEngagementManagerFlag"
              }
            ],
            staticClass: "tagged-contacts plus-button plus-button--small"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.addEngagementManagerFlag,
              expression: "addEngagementManagerFlag"
            }
          ],
          staticClass: "add-multiselect-group"
        },
        [
          _c(
            "div",
            { staticClass: "custom-field user-field custom-multiselect" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addEngagementManagerFlag,
                    expression: "addEngagementManagerFlag"
                  }
                ],
                ref: "engagementManager",
                attrs: {
                  options: _vm.allActiveUsers,
                  "option-height": 42,
                  "show-labels": false,
                  multiple: false,
                  "allow-empty": false,
                  label: "name",
                  "track-by": "id"
                },
                on: {
                  close: function($event) {
                    _vm.addEngagementManagerFlag = false
                  },
                  input: function($event) {
                    return _vm.engagementManagerChanged()
                  }
                },
                model: {
                  value: _vm.project.engagement_manager,
                  callback: function($$v) {
                    _vm.$set(_vm.project, "engagement_manager", $$v)
                  },
                  expression: "project.engagement_manager"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }